import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-85abab60"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "w"
};
const _hoisted_2 = {
  class: "main"
};
import SectionHeader from './SectionHeader.vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    bg: String,
    isWhiteTheme: {
      type: Boolean,
      default: false
    },
    title: String
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "section-container",
        style: _normalizeStyle({
          backgroundImage: __props.bg
        })
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(SectionHeader, {
        title: __props.title,
        isWhiteTheme: __props.isWhiteTheme
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "action")]),
        _: 3
      }, 8, ["title", "isWhiteTheme"]), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")])])], 4);
    };
  }

});